(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2125],{

/***/ 52125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ selectSort; }
});

// EXTERNAL MODULE: ./components/index.js + 177 modules
var components = __webpack_require__(74030);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./components/selectSort/SelectSort.module.scss
var SelectSort_module = __webpack_require__(70070);
var SelectSort_module_default = /*#__PURE__*/__webpack_require__.n(SelectSort_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/selectSort/SelectSort.js






var SelectSort = function SelectSort(_ref) {
  var _selectedItem$name;

  var name = _ref.name,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      selectedSorting = _ref.selectedSorting,
      _onChange = _ref.onChange,
      onOpen = _ref.onOpen;
  var defaultSort = items[0];
  var selectedItem = items.find(function (item) {
    return item.value === selectedSorting;
  }) || defaultSort;
  var headTitle = (_selectedItem$name = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.name) !== null && _selectedItem$name !== void 0 ? _selectedItem$name : '';
  return /*#__PURE__*/(0,jsx_runtime.jsx)(components/* SelectBase */.Ky, {
    title: headTitle,
    closeOnClick: true,
    onOpen: onOpen,
    children: items.map(function (item) {
      var title = item.name,
          value = item.value;
      var isDefault = defaultSort.value === value;
      var checked = selectedItem.value === value;
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (SelectSort_module_default()).item,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
          className: (SelectSort_module_default()).radio,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            className: (SelectSort_module_default()).input,
            type: "radio",
            name: name,
            value: value,
            checked: checked,
            onChange: function onChange() {
              return _onChange(isDefault ? null : value);
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            "data-sort": title,
            className: (0,clsx_m/* default */.Z)((SelectSort_module_default()).title, checked && (SelectSort_module_default()).titleChecked),
            children: title
          })]
        })
      }, value);
    })
  });
};

/* harmony default export */ var selectSort_SelectSort = (SelectSort);
;// CONCATENATED MODULE: ./components/selectSort/index.js

/* harmony default export */ var selectSort = (selectSort_SelectSort);

/***/ }),

/***/ 70070:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"SelectSort_item__lf8hR","radio":"SelectSort_radio__LuuM2","input":"SelectSort_input__U_His","title":"SelectSort_title__PJBD_","titleChecked":"SelectSort_titleChecked__9LQDw","load":"SelectSort_load__XFtjP"};

/***/ })

}]);